import { useWidgetStore } from '@/state/widgetStore';
import { ChartCard } from './ChartCard';

export function ChartCardOverlay() {
  const charts = useWidgetStore((s) => s.charts);
  if (charts.length === 0) return null;
  return (
    <div className="pointer-events-none absolute left-4 top-4 z-30 flex max-h-[calc(100%-2rem)] flex-col gap-3 overflow-y-auto">
      {charts.map((c) => (
        <ChartCard key={c.id} card={c} />
      ))}
    </div>
  );
}
